
<ci-button
  class="actions-buttons__button"
  class-name="ci-btn-primary-s-filled"
  [disabled]="isActionsButtonsDisabled()"
  [arial-label]="'Comenzar Ruta' | translate"
  (click)="handleStartRouteClick()"
>
  {{ 'Comenzar Ruta' | translate }}
</ci-button>

<div class="actions-buttons__edit-button-container">
    <ci-button
      class="actions-buttons__button actions-buttons__button--edit"
      class-name="ci-btn-primary-s-outlined"
      [disabled]="isActionsButtonsDisabled()"
      [arial-label]="'Editar Ruta' | translate"
      icon-name="edit"
      (click)="handleEditRouteClick()"
    >
      {{ 'Editar Ruta' | translate }}
    </ci-button>
    
    <ci-button
      class="actions-buttons__button actions-buttons__button--ticket"
      class-name="ci-btn-primary-s-filled"
      [arial-label]="'Comprar Billetes' | translate"
      icon-name="gestion-contenidos-agenda-eventos"
      (click)="handleBuyTicketsClick()"
    >
      {{ getLabelTransportPayment() | translate }}
    </ci-button>
</div>
